export enum PromotionProgramPeriodError {
  DatesNotWithinAProgramPeriod = 'datesNotWithinAProgramPeriod',
  EndDateAfterFutureProgramEndDate = 'endDateAfterFutureProgramEndDate',
  EndDateAfterProgramEndDate = 'endDateAfterProgramEndDate',
  StartDateBeforeProgramStartDate = 'startDateBeforeProgramStartDate',
}

export interface PromotionProgramPeriod {
  endDate: string,
  id: string,
  isFuture: boolean,
  startDate: string,
}

export type PromotionProgramPeriodResult =
  | { error: PromotionProgramPeriodError, programId?: string }
  | { error?: never, programId: string };

/**
 * Finds the program a promotion's dates fall in, from the retailer's active and future programs.
 * The promotion must fit inside one program, except that it may start before a future program.
 */
export function findPromotionProgramPeriod (
  programs: PromotionProgramPeriod[],
  startDate: string,
  endDate: string,
): PromotionProgramPeriodResult {
  let programId: string | null = null;

  for (const program of programs) {
    if (startDate >= program.startDate && startDate <= program.endDate) {
      if (endDate > program.endDate) {
        return {
          error: program.isFuture
            ? PromotionProgramPeriodError.EndDateAfterFutureProgramEndDate
            : PromotionProgramPeriodError.EndDateAfterProgramEndDate,
          programId: program.id,
        };
      }
      programId = program.id;
    } else if (endDate <= program.endDate && endDate >= program.startDate) {
      if (!program.isFuture && startDate < program.startDate) {
        return {
          error: PromotionProgramPeriodError.StartDateBeforeProgramStartDate,
          programId: program.id,
        };
      }
      programId = program.id;
    }
  }

  if (!programId) {
    return { error: PromotionProgramPeriodError.DatesNotWithinAProgramPeriod };
  }
  return { programId };
}
